import { render } from "./UseCaseAclTree.vue?vue&type=template&id=13e2bde3"
import script from "./UseCaseAclTree.vue?vue&type=script&lang=js"
export * from "./UseCaseAclTree.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__